/**
 * Mirrors ForensicNotes.Model.Enums.eNoteContentType on the API.
 * Source of truth: src/ForensicNotes.Model/Enums/eNoteContentType.cs
 *
 * WHY THIS EXISTS. `CreateTextNoteInTicksAndTimestamp` declared
 * `noteContentType: string`, so any string compiled. The batch quick-add-note
 * dialog sent the literal `'text'`, which is neither a member name nor a number,
 * so ASP.NET Core model binding failed and [ApiController] returned 400 before
 * the action body ever ran. Every batch note POST failed, including the
 * "retry failed" button, which sent the same value and so failed identically on
 * every press.
 *
 * The 400 was correct. The client was wrong. Typing the parameter is the actual
 * fix: changing the two literals alone would leave the next caller free to make
 * the same mistake.
 *
 * VALUES ARE SENT AS NUMBERS. The API accepts a member name or a number;
 * numbers are what every other call site in this app already sends, so the
 * service serialises `String(noteContentType)` and these values must stay
 * numerically identical to the C# enum. If a member is added there, add it here.
 */
export enum eNoteContentType {
  DefaultNote = 0,
  TextOnly = 1,
  Image = 2,
  Video = 3,
  Audio = 4,
  Signature = 5,
  Weather = 6,
  Location = 7,
  Person = 8,
  WitnessRequestResponse = 9,
  WitnessRequestSent = 10,
  InvestPhoneCall = 11,
  InvestTextMediaMessage = 12,
  InvestEmail = 13,
}
